module.exports = __webpack_public_path__ + "static/media/stepper-theme-icon.94cdc574.svg";